import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Register from "../pages/Register";
import MindMap from "../pages/MindMap";
import TreePage from "../pages/TreePage";
import TreePage1 from "../pages/TreePage1";
import PublicNavbar from "../components/PublicNavbar"; // Import the new navbar
import ScrollTop from "../components/ScrollTop";

import ConnectingHinduHome from "../pages/connectingHindu/ConnectingHinduHome";
import News from "../pages/connectingHindu/News";
import Video from "../pages/connectingHindu/Video";
import Audio from "../pages/connectingHindu/Audio";
import Blog from "../pages/connectingHindu/Blog";
import Features from "../pages/connectingHindu/Features";
import Profile from "../pages/connectingHindu/Profile";
import Business from "../pages/connectingHindu/Business";
import Quote from "../pages/connectingHindu/Quote";
import Poll from "../pages/connectingHindu/Poll";
import FAQ from "../pages/connectingHindu/Faq";
import Ebooks from "../pages/connectingHindu/Ebooks";
import ConnectHome from "../pages/connectingHindu/connectHome/ConnectHome";
import ConnectDetailsPage from "../pages/connectingHindu/connectHome/ConnectDetailsPage";
import Teams from "../pages/connectingHindu/Team";
import VirtualLayout from "../pages/Virtual/VirtualLayout";
import VirtualDetailPage from "../pages/Virtual/VirtualDetailPage";
import WebStory from "../pages/connectingHindu/WebStory";
import { saffronRout } from "../Url";

const PublicLayout = () => (
  <div className="bg-gray-50">
    <PublicNavbar /> {/* Add the navbar here */}
    <ScrollTop />
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        {/* <Route path="/mind-map" element={<MindMap />} /> */}
        {/* <Route path="/the-hindu-today" element={<TreePage />} /> */}

        <Route path="/the-hindu-today" element={<TreePage1 />} />

        <Route
          path={saffronRout}
          element={<ConnectingHinduHome />}
        >
          {/* <Route index element={<Navigate to="home" replace />} /> */}
          <Route path="home" element={<ConnectHome />} />
          <Route path="details/:type/:slug" element={<ConnectDetailsPage />} />

          <Route path="news" element={<News />} />
          <Route path="video" element={<Video />} />
          <Route path="audio" element={<Audio />} />
          <Route path="blog" element={<Blog />} />
          <Route path="feature" element={<Features />} />
          <Route path="webstory" element={<WebStory />} />
          <Route path="profile" element={<Profile />} />
          <Route path="business" element={<Business />} />
          <Route path="quote" element={<Quote />} />
          <Route path="poll" element={<Poll />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="ebook" element={<Ebooks />} />
          <Route path="team" element={<Teams />} />
        </Route>

        <Route
          path="/virtual-sevak"
          element={<Navigate to="/virtual-sevak/organizations" replace />}
        />
        {/* <Route path="/virtual-sevak/:module/:country?/:state?/:city?" element={<VirtualLayout />}> */}

        <Route path="/virtual-sevak/:module" element={<VirtualLayout />}>
          <Route path=":slug" element={<VirtualDetailPage />} />
        </Route>
      </Routes>
    </main>
  </div>
);

export default PublicLayout;
